// Official artwork copied byte-for-byte into public; never depend on build output.
export const brandLogo = `${process.env.PUBLIC_URL || ''}/assets/brand/Logo-nsara.jpg`;
